<template>
  <v-row justify-center>
    <v-dialog :value="value" @input="$emit('input')" max-width="660">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-form v-model="valid" ref="form">
          <v-card-text text-xs-center class="text-xs-center">
            <v-flex xs12 pl-3 pr-3>
              
              <vue-drawing-canvas 
                ref="VueCanvasDrawing" 
                :background-image="planoParaPintar"
                :image.sync="image"
                saveAs="png"
                />

              <v-text-field v-model="pictureDescription" :label="this.$t('addPicture.descripcion')" :rules="[rules.obligatorio,rules.max(90)]"></v-text-field>
            </v-flex>
          </v-card-text>
        </v-form>
        <v-card-actions class="justify-center">
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="reiniciarPlano()">{{this.$t('addPicture.restart')}}</v-btn>
          <v-btn text @click.native="$emit('input')">{{this.$t('addPicture.cancelar')}}</v-btn>
          <v-btn color="primary" @click="add()" text :disabled="disabled || files === []">{{this.$t('addPicture.guardar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import exif from 'exif-js'
import ImageRotation from 'image-rotation'
import VueDrawingCanvas from "vue-drawing-canvas";

export default {
  components: {
    VueDrawingCanvas
  },
  mixins: [rulesMixin],
  name: 'add-picture',
  props: {
    value: Boolean,
    incidence: String,
    carpeta: String,
    title: String,
    visit: String,
    plano: String
  },
  data () {
    return {
      picture: null,
      files: [],
      pictureDescription: '',
      tipoObjetoId: 2,
      carpetaId: '', // fotos apertura - 1 | fotos cierre - 3 | docs - 5
      objetoId: 816, // id incidencia - prop => incidence
      imageBase64: '',
      disabled: false,
      valid: true,
      image: null,
      planoParaPintar: null
    }
  },
  async mounted () {
    /*
    try{
      const blob = this.b64toBlob(this.plano);
      this.planoParaPintar = URL.createObjectURL(blob);
      await this.$refs.VueCanvasDrawing.redraw();
    } catch (e) {
      console.log(e)
    }
    */
  },
  computed: {
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      addPicture: 'incidencias/addPicture',
      getSmallPicturesCierre: 'incidencias/getSmallPicturesCierre',
      addDocument: 'incidencias/addDocument',
      getPlanos: 'inmuebles/getPlanos'
    }),
    b64toBlob (b64Data, contentType='', sliceSize=512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    async reiniciarPlano() {
      await this.$refs.VueCanvasDrawing.reset();
    },
    async add () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
        return
      }
      //Mostramos loader
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      })
      this.disabled = true
      
      const values = {
        picture: this.image.split(',')[1],
        description: this.pictureDescription + '-plan',
        name: this.pictureDescription + '-plan',
        mime: 'image/png',
        tipoObjetoId: 2,
        carpetaId: this.carpeta,
        objetoId: this.incidence
      }

      this.addPicture(values)
        .then(() => {
          this.uploadSuccess()
        })
        .catch(e => {
          this.loader.hide()
          return e
        })
        
    },
    async addNewElement (file, index) {
      // Nos copiamos el objeto this, ya que más adelante lo perdemos.
      var thisAux = this
      //Obtenemos informacion EXIF de la imagen
      exif.getData(file, function() {
        var reader = new FileReader()
        reader.readAsDataURL(this)
        reader.onload = (e) => {
          if(this.type.indexOf('image') >= 0) {
            // Angulo de rotación, por defecto es 0 (Esta funcionando con el 0 para todas las imagenes, es por ello por lo que lo dejo así)
            var rotationAngle = 0
            // Rotamos la imagen
            let imageRotate = new ImageRotation(this)
            imageRotate.generate(rotationAngle, 'image/png').then(result => {
              this.imageBase64 = result
              const arrImageSplit = this.imageBase64.split(',')
              // Una vez la imagen ha sido rotada a su angulo correcto, se dispone a guardar la imagen.
              if (thisAux.carpeta === '5') {
                const values = {
                  document: arrImageSplit[1],
                  description: thisAux.pictureDescription + '-' + index,
                  name: file.name,
                  mime: file.type,
                  tipoObjetoId: 2,
                  carpetaId: thisAux.carpeta,
                  objetoId: thisAux.incidence
                }
                thisAux.addDocument(values)
                  .then(() => {
                    thisAux.uploadSuccess()
                  })
                  .catch(e => {
                    thisAux.loader.hide()
                    return e
                  })
              } 
              else if (thisAux.carpeta === '11') {
                const values = {
                  document: arrImageSplit[1],
                  description: thisAux.pictureDescription + '-' + index,
                  name: file.name,
                  mime: file.type,
                  tipoObjetoId: 3,
                  carpetaId: thisAux.carpeta,
                  objetoId: thisAux.visit
                }
                thisAux.addDocument(values)
                  .then(() => {
                    thisAux.uploadSuccess()
                  })
                  .catch(e => {
                    thisAux.loader.hide()
                    return e
                  })
              } 
              else {
                const values = {
                  picture: arrImageSplit[1],
                  description: thisAux.pictureDescription + '-' + index,
                  name: file.name,
                  mime: file.type,
                  tipoObjetoId: 2,
                  carpetaId: thisAux.carpeta,
                  objetoId: thisAux.incidence
                }
                thisAux.addPicture(values)
                  .then(() => {
                    thisAux.uploadSuccess()
                  })
                  .catch(e => {
                    thisAux.loader.hide()
                    return e
                  })
              }
            })
          } else {
            const base64String = e.target.result
                .replace('data:', '')
                .replace(/^.+,/, '');

            var tipoObjetoIdAux = 2
            var objetoIdAux = thisAux.incidence
            if (thisAux.carpeta === '11') {
              tipoObjetoIdAux = 3
              objetoIdAux = thisAux.visit
            }
           
            const values = {
              document: base64String,
              description: thisAux.pictureDescription + '-' + index,
              name: file.name,
              mime: file.type,
              tipoObjetoId: tipoObjetoIdAux,
              carpetaId: thisAux.carpeta,
              objetoId: objetoIdAux
            }
            thisAux.addDocument(values)
              .then(() => {
                thisAux.uploadSuccess()
              })
              .catch(e => {
                thisAux.loader.hide()
                return e
              })
          }
        }
      })
    },
    uploadSuccess () {
      this.files = []
      this.pictureDescription = ''
      this.carpetaId = ''
      this.imageBase64 = ''
      this.$emit('success')
      this.$emit('input')
      this.disabled = false
      this.loader.hide()
    },
  },  
  watch: {
    plano: async function () {
      try{
        const blob = this.b64toBlob(this.plano);
        this.planoParaPintar = URL.createObjectURL(blob);
        await this.$refs.VueCanvasDrawing.redraw();
      } catch (e) {
        console.log(e)
      }
    },
    value: async function (currentValue) {
      if(currentValue === true) {
        await this.$refs.VueCanvasDrawing.reset();
      }
    }
  }
}
</script>
